import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';

import {
    InvoiceStringObj,
    dataARTransactionItem,
    PostCreatePaymentForLedger,
    dataARPaymentDistrib,
    dataARClaim,
    dataARLedger,
    dataARPayment,
    LOCIDForPaymentObj,
    cfgARMerchantAccount,
    dataInsuranceExplosion,
    dataPatient,
    enumValidValueItem,
    dataPatientCaseWorkItem,
    dataFeeSchedule,
    dataFeeScheduleItem,
    dataPatientInsuranceCoverage,
    dataPatientCase,
    dataFeeScheduleDoctor,
    cfgCaseProcedure,
    dataAppointment,
    dataARTransaction,
    dataARPaymentPlan,
    dataARPaymentPlanItem,
} from './_models/ar.models';
import {DataPatientCaseWorkItemModel} from '../../models/accountsReceivable/data-patient-case-work-item.model';
import {FeeScheduleItemFeeDataModel} from '../../models/fee-schedule/fee-schedule-item-fee-data.model';
import {AdditionalInfo, DataARClaimModel} from '../../models/accountsReceivable/data-ar-claim.model';
import {DataARTransactionItemModel} from '../../models/accountsReceivable/data-ar-transaction-item.model';
import {PatientDataModel} from '../../models/patient/patient-data.model';
import {PatientInsuranceListViewDataModel} from '../insurance/models/patient-insurance-list-view-data-view.model';
import {FeeScheduleDoctorDataARModel} from '../../models/accountsReceivable/fee-schedule-doctor-data-ar.model';
import {CreateTransactionItemModel} from '../../models/accountsReceivable/create-transaction-item.model';
import {PostTransactionItemModel} from '../../models/accountsReceivable/post-transaction-item.model';
import {DataARPaymentPlanModel} from '../../models/accountsReceivable/data-ar-payment-plan.model';
import {DataARLedgerModel} from '../../models/accountsReceivable/data-ar-ledger.model';
import {CfgARFeeDiscountModel} from '../../models/accountsReceivable/cfg-ar-fee-discount.model';
import {DataARLedgerListModel} from './models/data-ar-ledger-list.model';
import {DoctorByTDOCIDModel} from './models/doctor-by-tdocid.model';
import {CreateClaimsModel} from './models/create-claims.model';
import {FeeVariablesModel} from './models/ar-fee-variables.model';
import {DataARClaimListModel} from './models/data-ar-claim-list';
import {DataARClaimItemListModel} from './models/data-ar-claim-item-list';
import {LOCIDModel} from './models/select-tdocid-locid.model';
import {CreatePaymentModel} from './models/create-payment.model';
import {DataARPaymentModel} from '../../models/accountsReceivable/data-ar-payment.model';
import {DataARPaymentDistribsModel} from '../../models/accountsReceivable/data-ar-payment-distribs.model';
import {GetPaymentDetailsForPaymentTransactionID} from './models/get-payment-details-for-payment-transactionid';
import {DataArPaymentAuditModel} from './models/data-ar-payment-audit.model';
import {InsuranceCompanyListModel} from './models/insurance-company-list.model';
import {CfgARAccountModel} from '../../models/accountsReceivable/cfg-ar-account.model';
import {RecallClaimModel} from './models/recall-claim.model';
import {ValidationResult} from './models/ValidationResult.model';
import {DataFeeScheduleItemFee4FeesJoinedModel} from '../fee-schedule/models/data-fee-scheduleItem-fee4fees-joined.model';
import {DataPatientCaseWorkItemToothSurfaceModel} from '../../models/teeth/data-patient-case-work-item-tooth-surface.model';
import {SavePaymentDistributionsModel} from './models/save-payment-distributions.model';
import {DataARClaimAttachmentModel} from '../../models/accountsReceivable/data-ar-claim-attachments.model';
import {DataARClaimsLogModel} from '../../models/accountsReceivable/data-ar-claims-log.model';
import {CfgARPaymentProcessorModel} from '../../models/accountsReceivable/cfg-ar-payment-processor.model';
import {PaymentProcessorDeviceListModel} from '../configuration/models/payment-processor-device-list.model';
import {DataARPaymentDistribsListModel} from './models/data-ar-payment-distribs-list.model';
import {DataARPaymentListModel} from './models/data-ar-payment-list.model';
import {CreateLedgerItemForPaymentModel} from './models/create-ledger-item-for-payment.model';
import {RectangleHealthTransactionPayload} from './models/rectangle-health-transaction-payload';
import {RectangleHealthTransactionResponseModel} from './models/rectangle-health-transaction-response-model';
import {InsurancePaymentOverpayListModel} from './models/insurance-payment-overpay-list.model';
import {SaveInsurancePaymentDistributionsModel} from './models/save-insurance-payment-distributions.model';
import {DataArLedgerCredits} from './models/data-ar-ledger-credits';
import {TdoUserParameters} from '../../models/configuration/user/tdo-user-parameters';
import {DataARCreditDebitReasonModel} from '../../models/accountsReceivable/data-ar-credit-debit-reason.model';
import { CreditCardRefundRequest } from '../../models/accountsReceivable/credit-card-refund-request.model';
import { CreditCardRefundResponse } from '../../models/accountsReceivable/credit-card-refund-response.model';
import { PaymentReceiptModel } from 'src/app/models/accountsReceivable/payment-receipt.model';
import { ITDOPaymentStatusResult } from '@tdo-inc/tdo-payment';
import { delay, retryWhen, scan, switchMap, takeWhile } from 'rxjs/operators';
import {NoteDataModel} from '../../models/notes/note-data.model';
import {DataArPaymentToken} from '../../models/accountsReceivable/data-ar-cc-payment-token';
import {CreditCardTokenPaymentResponse} from "../../models/accountsReceivable/credit-card-token-payment-response";
import {CreditCardRefundablePaymentModel} from '../../models/accountsReceivable/credit-card-refundable-payment.model';
import {UpdateClaimItemCommentModel} from './models/update-claim-item-comment.model';
import { StaticDataService } from 'src/app/services/static-data.service';
import {DataARClaimNarrativeAttachmentModel} from './models/data-ar-claim-narrative-attachment.model';
import { VoidValidationModel } from 'src/app/models/accountsReceivable/void-validation.model';

@Injectable({
    providedIn: 'root'
})
export class ARService {
    constructor(
        private http: HttpClient,
        private readonly staticDataService: StaticDataService
    ) { }

  savePatientOverwriteFeeSchedule(PatientId: string, DocFeeScheduleID: string): Observable<string> {
    return this.http.get<string>(`api/accountReceivable/save-patient-overwrite-docfeesched/${PatientId}/${DocFeeScheduleID}`);
  }


  getClaimProcessorsForLocation(LOCID: string): Observable<any[]> {
    return this.http.get<any[]>('/api/claim-processor-configuration/get-claim-processor-for-location/${LOCID}');
  }

  getClaimDetails(ARClaimID: string): Observable<DataARClaimListModel[]> {
        return this.http.get<DataARClaimListModel[]>(`api/accountReceivable/get-claim-details/${ARClaimID}`);
    }

    getClaimStatus(ARClaimID: string): Observable<string> {
        return this.http.get<string>(`api/accountReceivable/get-claim-status/${ARClaimID}`);
    }

    getClaimValidationStatus(ARClaimID: string): Observable<string> {
      return this.http.get<string>(`api/accountReceivable/get-claim-validation-status/${ARClaimID}`);
    }

    getClaimLog(ARClaimID: string): Observable<DataARClaimsLogModel[]> {
        return this.http.get<DataARClaimsLogModel[]>(`api/accountReceivable/get-claim-log/${ARClaimID}`);
    }

    recallClaim(payload: RecallClaimModel): Observable<number> {
        return this.http.post<number>('/api/accountReceivable/recall-claim', payload);
    }

    getDXClaimValidationResult(ARClaimID: string): Observable<ValidationResult> {
        return this.http.get<ValidationResult>(`api/accountReceivable/get-dx-claim-validation-result/${ARClaimID}`);
    }

    getInternalClaimValidationResult(ARClaimID: string): Observable<ValidationResult> {
        return this.http.get<ValidationResult>(`api/accountReceivable/get-internal-claim-validation-result/${ARClaimID}`);
    }

    getDXClaimSubmission(): Observable<string> {
        return this.http.get<string>('api/accountReceivable/get-dx-claim-submission');
    }

    sendClaimsToDentalExchange(): Observable<dataARClaim[]> {
        return this.http.get<dataARClaim[]>('api/accountReceivable/send-claims-to-dental-exchange');
    }

    getPaymentAuditList(PaymentID: string): Observable<DataArPaymentAuditModel[]> {
        return this.http.get<DataArPaymentAuditModel[]>(`api/accountReceivable/get-payment-audit-list/${PaymentID}`);
    }

    CreatePaymentDistribution(paymentDistribution: DataARPaymentDistribsModel): Observable<DataARPaymentDistribsModel> {
        return this.http.post<DataARPaymentDistribsModel>('/api/accountReceivable/create-payment-distribution', paymentDistribution);
    }

    // savePaymentDistributions(ledgerItems: DataARLedgerListModel[], PaymentID: string, ClientPostDate: Date): Observable<number> {
    //   return this.http.post<number>(`/api/accountReceivable/save-payment-distributions/${PaymentID}/${ClientPostDate}`, ledgerItems);
    // }
    savePaymentDistributions(ledgerItems: SavePaymentDistributionsModel): Observable<number> {
        return this.http.post<number>('/api/accountReceivable/save-payment-distributions', ledgerItems);
    }

    saveInsurancePaymentDistributions(claims: DataARClaimListModel[], PaymentID: string, insuranceOverPayList: InsurancePaymentOverpayListModel[], insuranceClaimItemOverPayList: InsurancePaymentOverpayListModel[], PatientID: string, claimRefusal: boolean): Observable<number> {
        const saveObj = new SaveInsurancePaymentDistributionsModel();
        saveObj.PaymentID = PaymentID;
        saveObj.dataARClaims = claims;
        saveObj.overPayList = insuranceOverPayList;
        saveObj.claimItemOverPayList = insuranceClaimItemOverPayList;
        saveObj.PatientID = PatientID;
        saveObj.isClaimRefusal = claimRefusal;
        return this.http.post<number>('/api/accountReceivable/save-insurance-payment-distributions', saveObj);
    }

    saveClaimItemComment(updateComment: UpdateClaimItemCommentModel): Observable<number> {
      return this.http.post<number>('/api/accountReceivable/update-claim-item-comment', updateComment);
    }

    createDataARPaymentRecord(createPayment: CreatePaymentModel): Observable<CreatePaymentModel> {
        return this.http.post<CreatePaymentModel>('/api/accountReceivable/create-payment-record', createPayment);
    }

    updateDataARPaymentRecord(updatePayment: DataARPaymentModel): Observable<DataARPaymentModel> {
        return this.http.post<DataARPaymentModel>('/api/accountReceivable/update-payment-record', updatePayment);
    }

    // updateDataARPaymentRecordStatusByTransactionSetupID(PaymentTransactionID: string, enumPaymentStatusID: string, ApprovedAmount: string, TransactionResponse: WorldpayTransactionResponseModel): Observable<DataARPaymentModel> {
    //     return this.http.post<DataARPaymentModel>(`/api/accountReceivable/update-payment-status-by-payment-transaction-id/${PaymentTransactionID}/${enumPaymentStatusID}/${ApprovedAmount}`, TransactionResponse);
    // }

    getPaymentById(paymentId: string): Observable<dataARLedger[]> {
        return this.http.get<dataARLedger[]>(`api/accountReceivable/getPaymentById/${paymentId}`);
    }

    getPaymentRecordByID(paymentId: string): Observable<DataARPaymentModel> {
        return this.http.get<DataARPaymentModel>(`api/accountReceivable/get-payment-record-by-id/${paymentId}`);
    }

    getPayment(paymentId: string): Observable<DataArPaymentAuditModel> {
        return this.http.get<DataArPaymentAuditModel>(`api/accountReceivable/get-payment/${paymentId}`);
    }

    getPaymentInsurance(paymentId: string): Observable<DataArPaymentAuditModel> {
        return this.http.get<DataArPaymentAuditModel>(`api/accountReceivable/get-payment-insurance/${paymentId}`);
    }

    getPaymentRefundDistributions(paymentId: string): Observable<DataARPaymentDistribsListModel> {
        return this.http.get<DataARPaymentDistribsListModel>(`api/accountReceivable/get-payment-refund-distributions/${paymentId}`);
    }

    getDetailsForPaymentTransactionID(PaymentTransactionID: string): Observable<GetPaymentDetailsForPaymentTransactionID> {
        return this.http.get<GetPaymentDetailsForPaymentTransactionID>(`api/accountReceivable/get-details-for-payment-transaction-id/${PaymentTransactionID}`);
    }

    checkForPaymentCompletedByWP(paymentId: string): Observable<boolean> {
        return this.http.get<boolean>(`api/accountReceivable/checkForPaymentCompletedByWP/${paymentId}`);
    }

    markPaymentAndDistribsAsNotDeleted(PaymentId: string): Observable<dataARPayment> {
        return this.http.get<dataARPayment>(`api/accountReceivable/markPaymentAndDistribsAsNotDeleted/${PaymentId}`);
    }

    processSuccessWPPayment(invoiceId: string): Observable<string> {
        return this.http.post<string>(`api/accountReceivable/processSuccessWPPayment/${invoiceId}`, {});
    }

    getLOCIDForPayments(PatientId: string): Observable<LOCIDForPaymentObj[]> {
        return this.http.get<LOCIDForPaymentObj[]>(`api/accountReceivable/getLOCIDForPayments/${PatientId}`);
    }

    getPaymentsForPatient(PatientId: string): Observable<DataARPaymentModel[]> {
        return this.http.get<DataARPaymentModel[]>(`api/accountReceivable/getPaymentsForPatient/${PatientId}`);
    }

    getBillableItems(PatientCaseId: string): Observable<any[]> {
        return this.http.get<any[]>(`api/accountReceivable/getBillableItmes/${PatientCaseId}`);
    }


    getPatientPayments(PatientId: string): Observable<DataARPaymentListModel[]> {
        return this.http.get<DataARPaymentListModel[]>(`api/accountReceivable/get-patient-payments/${PatientId}`);
    }

    getPaymentDistributionsForPaymentID(PaymentID: string, PatientID: string): Observable<DataARPaymentDistribsListModel[]> {
        return this.http.get<DataARPaymentDistribsListModel[]>(`api/accountReceivable/get-payment-distributions-for-payment/${PaymentID}/${PatientID}`);
    }

  getCCPayments(PatientID: string, initialDate: string, endDate: string): Observable<DataARPaymentListModel[]> {
    const params = new HttpParams()
    .set('PatientID', PatientID)
    .set('initialDate', initialDate)
    .set('endDate', endDate);
    return this.http.get<DataARPaymentListModel[]>(`api/accountReceivable/getccPayments/`, {params});
  }

  getPaymentDistributionsForLedgerItem(LedgerId: string): Observable<DataARPaymentListModel[]> {
    return this.http.get<DataARPaymentListModel[]>(`api/accountReceivable/get-payments-for-ledger-item/${LedgerId}`);
  }

  getPaymentDistributionsForCreditLedgerItem(LedgerId: string): Observable<DataARPaymentListModel[]> {
    return this.http.get<DataARPaymentListModel[]>(`api/accountReceivable/get-payment-distributions-for-credit-ledger-item/${LedgerId}`);
  }

    getPaymentDistributionsForLedgerTransaction(TransactionItemId: string): Observable<DataARPaymentListModel[]> {
        return this.http.get<DataARPaymentListModel[]>(`api/accountReceivable/get-payments-for-ledger-transaction/${TransactionItemId}`);
    }

    getMerchantAccount(LOCID: string): Observable<cfgARMerchantAccount> {
        return this.http.get<cfgARMerchantAccount>(`api/accountReceivable/getMerchantAccount/${LOCID}`);
    }

    getNewNonSequentialGuids(): Observable<string[]> {
        return this.http.get<string[]>('api/accountReceivable/getNewNonSequentialGuids');
    }

    getNewFormGuids(): Observable<string[]> {
        return this.http.get<string[]>('api/accountReceivable/getNewGuids');
    }

    // getPaymentIdForTransaction_WorldPayDEV(payload: WorldPayPaymentObj): Observable<WorldPayTransactionRef> {
    //   return this.http.post<WorldPayTransactionRef>(`api/accountReceivable/getPaymentIdForTransactionWorldPayDEV`, payload);
    // }
    //
    // getPaymentIdForTransaction_WorldPay(payload: WorldPayPaymentObj): Observable<WorldPayTransactionRef> {
    //   return this.http.post<WorldPayTransactionRef>(`api/accountReceivable/getPaymentIdForTransactionWorldPay`, payload);
    // }

    // createTransactionSetupIdForWorldPay(payload: WorldpayTransactionSetupModel): Observable<WorldpayTransactionSetupResponseModel> {
    //     return this.http.post<WorldpayTransactionSetupResponseModel>('api/accountReceivable/getTransactionSetupIdForWorldPay', payload);
    // }

    // getTransactionDetailsForWorldPayTransactionID(payload: WorldpayTransactionSetupModel): Observable<WorldpayTransactionSetupResponseModel> {
    //     return this.http.post<WorldpayTransactionSetupResponseModel>('api/accountReceivable/getTransactionDetailsForWorldPayTransactionID', payload);
    // }

    getPatientsFromIds(PatientIds: string[]): Observable<dataPatient[]> {
        return this.http.post<dataPatient[]>('/api/accountReceivable/getPatientsFromIds', PatientIds);
    }

    getAllClaims(): Observable<DataARClaimListModel[]> {
        return this.http.get<DataARClaimListModel[]>('/api/accountReceivable/get-all-claims');
    }

    // getAllClaimsWithItemsByOrganizationID(OrganizationID: string, SearchClosed: boolean, SearchTerm: string, PatientID: string): Observable<DataARClaimListModel[]> {
    //   return this.http.get<DataARClaimListModel[]>(`/api/accountReceivable/get-all-claims-by-insurance/${InsuranceID}/${SearchClosed}/${SearchTerm}/${PatientID}`);
    // }

    getAllClaimsWithItems(InsuranceID: string, OrganizationID: string, SearchClosed: boolean, SearchTerm: string, PatientID: string): Observable<DataARClaimListModel[]> {
        return this.http.get<DataARClaimListModel[]>(`/api/accountReceivable/get-all-claims-by-insurance/${InsuranceID}/${OrganizationID}/${SearchClosed}/${SearchTerm}/${PatientID}`);
    }

    getClaimItemList(ARClaimID: string): Observable<DataARClaimItemListModel[]> {
        return this.http.get<DataARClaimItemListModel[]>(`/api/accountReceivable/getClaimItemList/${ARClaimID}`);
    }

    getNarrativeAttachementForClaim(ARClaimID: string): Observable<NoteDataModel[]> {
        return this.http.get<NoteDataModel[]>(`/api/notes/get-narrative-attachments-for-claim/${ARClaimID}`);
    }

    getClaimAttachements(ARClaimID: string): Observable<DataARClaimAttachmentModel[]> {
        return this.http.get<DataARClaimAttachmentModel[]>(`/api/accountReceivable/get-claim-attachments/${ARClaimID}`);
    }

    deleteClaimNarrativeAttachment(ARClaimID: string, NoteID: string): Observable<number> {
        return this.http.post<number>(`/api/accountReceivable/delete-claim-narrative-attachment/${ARClaimID}/${NoteID}`, {});
    }

    saveClaimAttachements(attachments: DataARClaimAttachmentModel[]): Observable<DataARClaimAttachmentModel[]> {
        return this.http.post<DataARClaimAttachmentModel[]>('/api/accountReceivable/save-claim-attachments', attachments);
    }

    removeClaimAttachements(attachments: DataARClaimAttachmentModel[]): Observable<DataARClaimAttachmentModel[]> {
        return this.http.post<DataARClaimAttachmentModel[]>('/api/accountReceivable/remove-claim-attachments', attachments);
    }

    getPatientClaims(PatientId: string): Observable<dataARClaim[]> {
        return this.http.get<dataARClaim[]>(`/api/accountReceivable/getPatientClaims/${PatientId}`);
    }

    getPatientClaimsTransactionItemIDs(PatientId: string): Observable<DataARClaimListModel[]> {
        return this.http.get<DataARClaimListModel[]>(`/api/accountReceivable/get-patient-claims-transaction-item-ids/${PatientId}`);
    }

    getExplosionCodesForInsurance(OrganizationId: string): Observable<dataInsuranceExplosion[]> {
        return this.http.get<dataInsuranceExplosion[]>(`/api/accountReceivable/getExplosionCodesForInsurance/${OrganizationId}`);
    }

    getPatientAndContact(PatientId: string): Observable<dataPatient> {
        return this.http.get<dataPatient>(`/api/accountReceivable/getPatientAndContact/${PatientId}`);
    }

    getPlanItemStatusEnums(): Observable<enumValidValueItem[]> {
        return this.http.get<enumValidValueItem[]>('/api/accountReceivable/getPlanItemStatusEnums');
    }

    getEnumsForClaims(): Observable<enumValidValueItem[]> {
        return this.http.get<enumValidValueItem[]>('/api/accountReceivable/getEnumsForClaims');
    }

    getDoctorsByTDOCID(): Observable<DoctorByTDOCIDModel[]> {
        return this.http.get<DoctorByTDOCIDModel[]>('/api/accountReceivable/getDoctorsByTDOCID');
    }

    getDoctorsByTDOCIDFees(): Observable<DoctorByTDOCIDModel[]> {
        return this.http.get<DoctorByTDOCIDModel[]>('/api/accountReceivable/get-doctors-by-tdocid-fees');
    }

  getDoctorsByLOCID(locid: number): Observable<DoctorByTDOCIDModel[]> {
    return this.http.get<DoctorByTDOCIDModel[]>(`/api/accountReceivable/get-doctors-by-locid/${locid}`);
  }
  getDoctorsARLocByLOCID(locid: string): Observable<any[]> {
    return this.http.get<any[]>(`/api/accountReceivable/get-doctors-ar-loc-by-locid/${locid}`);
  }

    getEnumStatusesForClaims(): Observable<enumValidValueItem[]> {
        return this.http.get<enumValidValueItem[]>('/api/accountReceivable/getEnumStatusesForClaims');
    }

    getEnumMethodsForClaims(): Observable<enumValidValueItem[]> {
        return this.http.get<enumValidValueItem[]>('/api/accountReceivable/get-enum-methods-for-claims');
    }

    getLedgerForPatient(PatientId: string): Observable<DataARLedgerListModel[]> {
        return this.http.get<DataARLedgerListModel[]>(`/api/accountReceivable/getLedgerForPatient/${PatientId}`);
    }

    getLedgerForPatient2(PatientId: string): Observable<DataARLedgerListModel[]> {
        return this.http.get<DataARLedgerListModel[]>(`/api/accountReceivable/getLedgerForPatient2/${PatientId}`);
    }

    getPatient(PatientId: string): Observable<PatientDataModel[]> {
        return this.http.get<PatientDataModel[]>(`/api/accountReceivable/getPatient/${PatientId}`);
    }

    getEnumValidValueItemsByValidValueName(ValidValueName: string): Observable<enumValidValueItem[]> {
            return this.staticDataService.getEnumValidValueItemsByValidValueName(ValidValueName);
        //return this.http.get<enumValidValueItem[]>(`/api/accountReceivable/getEnumValidValueItemsByValidValueName/${ValidValueName}`);
    }

    getDoctorsByPatientLedger(PatientId: string): Observable<DoctorByTDOCIDModel[]> {
        return this.http.get<DoctorByTDOCIDModel[]>(`/api/accountReceivable/getDoctorsByPatientLedger/${PatientId}`);
    }

    getCaseDataTransactions(CaseWorkItemId: string): Observable<dataARTransactionItem[]> {
        return this.http.get<dataARTransactionItem[]>(`/api/accountReceivable/getCaseDataTransactions/${CaseWorkItemId}`);
    }

    getPostedPatientDataTransactionItems(PatientId: string, ): Observable<DataARTransactionItemModel[]> {
        return this.http.get<DataARTransactionItemModel[]>(`/api/accountReceivable/getPostedPatientDataTransactionItems/${PatientId}`);
    }

  getPatientDataTransactionItems(PatientId: string, calculateBy:string =''): Observable<DataARTransactionItemModel[]> {
    return this.http.get<DataARTransactionItemModel[]>(`/api/accountReceivable/getPatientDataTransactionItems/${PatientId}/${calculateBy}`);
  }

    getPatientDataTransactionItemsForClaimWizard(PatientId: string, ): Observable<DataARTransactionItemModel[]> {
        return this.http.get<DataARTransactionItemModel[]>(`/api/accountReceivable/getPatientDataTransactionItemsForClaimWizard/${PatientId}`);
    }

    getRealClaimDataForClaimWizard(PatientId: string): Observable<DataARTransactionItemModel[]> {
      return this.http.get<DataARTransactionItemModel[]>(`/api/accountReceivable/get-real-claim-data-for-claim-wizard/${PatientId}`);
    }

    getPreDeterminationClaimDataForClaimWizard(PatientId: string): Observable<DataARTransactionItemModel[]> {
      return this.http.get<DataARTransactionItemModel[]>(`/api/accountReceivable/get-predetermination-claim-data-for-claim-wizard/${PatientId}`);
    }

    getCaseWorkItems(PatientId: string): Observable<dataPatientCaseWorkItem[]> {
        return this.http.get<dataPatientCaseWorkItem[]>(`/api/accountReceivable/getCaseWorkItems/${PatientId}`);
    }

    getFeeSchedules(): Observable<dataFeeSchedule[]> {
        return this.http.get<dataFeeSchedule[]>('/api/accountReceivable/getFeeSchedules');
    }

    getFeeScheduleItems(FeeScheduleId: string): Observable<dataFeeScheduleItem[]> {
        return this.http.get<dataFeeScheduleItem[]>(`/api/accountReceivable/getFeeScheduleItems/${FeeScheduleId}`);
    }

    // getFeeScheduleChildItems(FeeScheduleId: string): Observable<dataFeeScheduleItem[]> {
    //   return this.http.get<dataFeeScheduleItem[]>(`/api/accountReceivable/getFeeScheduleChildItems/${FeeScheduleId}`);
    // }

    getFeeScheduleChildItems(DocFeeScheduleID: string): Observable<DataFeeScheduleItemFee4FeesJoinedModel[]> {
        return this.http.get<DataFeeScheduleItemFee4FeesJoinedModel[]>(`/api/accountReceivable/getFeeScheduleChildItems/${DocFeeScheduleID}`);
    }

    getAllInsuranceOrganizations(): Observable<InsuranceCompanyListModel[]> {
        return this.http.get<InsuranceCompanyListModel[]>('/api/accountReceivable/get-all-insurance-organizations');
    }

    getAllARAccounts(): Observable<CfgARAccountModel[]> {
        return this.http.get<CfgARAccountModel[]>('/api/accountReceivable/get-all-ar-accounts');
    }

    getAllDoctorARLocations(): Observable<CfgARAccountModel[]> {
        return this.http.get<CfgARAccountModel[]>('/api/accountReceivable/get-all-data-ar-locations');
    }

    getAllDoctorARLocationsByLOCID(LOCID: number): Observable<CfgARAccountModel[]> {
        return this.http.get<CfgARAccountModel[]>(`/api/accountReceivable/get-all-data-ar-locations-by-locid/${LOCID}`);
    }

    getInsuranceOrganizations(PatientId: string): Observable<PatientInsuranceListViewDataModel[]> {
        return this.http.get<PatientInsuranceListViewDataModel[]>(`/api/accountReceivable/getInsuranceOrganizations/${PatientId}`);
    }

    getInsuranceOrganizationsForPatientInsurancePayment(PatientId: string): Observable<InsuranceCompanyListModel[]> {
        return this.http.get<InsuranceCompanyListModel[]>(`/api/accountReceivable/get-all-insurance-organizations-for-patient-compact/${PatientId}`);
    }

    // need model for this
    getInsuranceDoctorFees(OrganizationId: string): Observable<FeeScheduleDoctorDataARModel[]> {
        return this.http.get<FeeScheduleDoctorDataARModel[]>(`/api/accountReceivable/getInsuranceDoctorFees/${OrganizationId}`);
    }
    getInsuranceDoctorFeesForPatient(PatientId: string): Observable<FeeScheduleDoctorDataARModel[]> {
        return this.http.get<FeeScheduleDoctorDataARModel[]>(`/api/accountReceivable/getInsuranceDoctorFeesForPatient/${PatientId}`);
    }


    getDiscountForDoctor(DoctorId: string, Level: string): Observable<CfgARFeeDiscountModel> {
        return this.http.get<CfgARFeeDiscountModel>(`/api/accountReceivable/getDiscountForDoctor/${DoctorId}/${Level}`);
    }

    getCoveragesForCodes(PatientId: string, CodeList: string[]): Observable<dataPatientInsuranceCoverage[]> {
        return this.http.post<dataPatientInsuranceCoverage[]>(`/api/accountReceivable/getCoveragesForCodes/${PatientId}`, CodeList);
    }

    getDataPatientCase(PatientCaseId: string): Observable<dataPatientCase> {
        return this.http.get<dataPatientCase>(`/api/accountReceivable/getDataPatientCase/${PatientCaseId}`);
    }

    getDoctorFeesForCodes(DoctorId: string, FeeScheduleId: string, CodeList: string[]): Observable<dataFeeScheduleDoctor[]> {
        return this.http.post<dataFeeScheduleDoctor[]>(`/api/accountReceivable/getDoctorFeesForCodes/${DoctorId}/${FeeScheduleId}`, CodeList);
    }

    removeDiscountOnServer(transactionItem: DataARTransactionItemModel): Observable<DataARTransactionItemModel[]> {
        return this.http.post<DataARTransactionItemModel[]>('/api/accountReceivable/removeDiscountOnServer', transactionItem);
    }

    applyDiscountOnServer(transactionItem: DataARTransactionItemModel, level: number, patientId: string): Observable<DataARTransactionItemModel[]> {
        return this.http.post<DataARTransactionItemModel[]>(`/api/accountReceivable/applyDiscountOnServer/${level}/${patientId}`, transactionItem);
    }

  getDiscounts(LOCID:any): Observable<CfgARFeeDiscountModel[]> {
    return this.http.get<CfgARFeeDiscountModel[]>(`/api/accountReceivable/${LOCID}/getDiscounts`);
  }

    getDiscountsForDoctorLocation(ProviderDoctorID: string, LOCID: number): Observable<CfgARFeeDiscountModel[]> {
        return this.http.get<CfgARFeeDiscountModel[]>(`/api/accountReceivable/getDiscountsForDoctorLocation/${ProviderDoctorID}/${LOCID}`);
    }

    getLocations(): Observable<LOCIDModel[]> {
        return this.http.get<LOCIDModel[]>('/api/accountReceivable/getLocations');
    }

    getCfgCaseProcedures(LOCID: string): Observable<cfgCaseProcedure[]> {
        return this.http.get<cfgCaseProcedure[]>(`/api/accountReceivable/getCfgCaseProcedures/${LOCID}`);
    }

    sendAlertToPatientForInvoice(patientId: string): Observable<boolean> {
        const host = location.origin;
        const payload = {
            host,
        };

        return this.http.post<boolean>(`/api/Patient/sendAlertToPatientForInvoice/${patientId}`, payload);
    }

    saveDataPaymentInvoice(paymentId: string, invoiceObject: InvoiceStringObj): Observable<dataARPayment> {
        const payload = {
            invoiceString: JSON.stringify(invoiceObject),
        };
        return this.http.post<dataARPayment>(`/api/accountReceivable/saveDataPaymentInvoice/${paymentId}`, payload);
    }

    deleteTransactionItem(transactionItem: dataARTransactionItem): Observable<dataARTransactionItem> {
        return this.http.post<dataARTransactionItem>('/api/accountReceivable/deleteTransactionItem', transactionItem);
    }

    closeCase(transactionItemObj: CreateTransactionItemModel): Observable<boolean> {
        return this.http.post<boolean>('/api/accountReceivable/closeCase', transactionItemObj);
    }

    createTransactionItems(transactionItemObjs: CreateTransactionItemModel[], transactionItemID: string = null): Observable<dataARTransaction> {
        return this.http.post<dataARTransaction>(`/api/accountReceivable/create-transaction-items/${transactionItemID}`, transactionItemObjs);
    }

    createTransactionItem(transactionItemObj: CreateTransactionItemModel): Observable<dataARTransactionItem> {
        return this.http.post<dataARTransactionItem>('/api/accountReceivable/createTransactionItem', transactionItemObj);
    }

    postTransactionItems(postTransactionItemsObj: PostTransactionItemModel): Observable<dataARLedger[]> {
        return this.http.post<dataARLedger[]>('/api/accountReceivable/postTransactionItems', postTransactionItemsObj);
    }

    saveTransactionItem(transactionItem: DataARTransactionItemModel): Observable<DataARTransactionItemModel> {
        return this.http.post<DataARTransactionItemModel>('/api/accountReceivable/saveTransactionItem', transactionItem);
    }

    saveDataPatientProperties(dp: PatientDataModel): Observable<boolean> {
        return this.http.post<boolean>('/api/accountReceivable/saveDataPatientProperties', dp);
    }

    createPaymentForLedgerItem(paymentItem: PostCreatePaymentForLedger): Observable<dataARPayment> {
        return this.http.post<dataARPayment>('/api/accountReceivable/createPaymentForLedgerItem', paymentItem);
    }

    verifyDistribsForPayment(PaymentId: string): Observable<boolean> {
        return this.http.post<boolean>(`/api/accountReceivable/verifyDistribsForPayment/${PaymentId}`, {});
    }

    stagePaymentForLedgerItem(paymentItem: PostCreatePaymentForLedger): Observable<dataARPayment> {
        return this.http.post<dataARPayment>('/api/accountReceivable/stagePaymentForLedgerItem', paymentItem);
    }

    savePaymentForLedgerItem(paymentDistrib: dataARPaymentDistrib): Observable<dataARPaymentDistrib> {
        return this.http.post<dataARPaymentDistrib>('/api/accountReceivable/savePaymentForLedgerItem', paymentDistrib);
    }

    saveDataClaim(dataClaim: DataARClaimModel): Observable<DataARClaimModel> {
        return this.http.post<DataARClaimModel>('/api/accountReceivable/saveDataClaim', dataClaim);
    }

    saveDataClaimAdditionalInfoJSON(dataARClaimList: DataARClaimListModel, AdditionalClaimParams : AdditionalInfo): Observable<DataARClaimModel> {
        const payload = {
            dataARClaimList,
            AdditionalClaimParams
          };
        return this.http.post<DataARClaimModel>('api/accountReceivable/saveDataClaimAdditionalInfoJSON/', payload);
    }

    getInsuranceClaimForLedgerID(LedgerId: string): Observable<any> {
        return this.http.get<any>(`/api/accountReceivable/get-insurance-claim-for-ledgerid/${LedgerId}`);
    }

    getAppointmentInformation(PatientCaseId: string): Observable<dataAppointment> {
        return this.http.get<dataAppointment>(`/api/infograb/getAppointmentInformationFromPatientCaseId/${PatientCaseId}`);
    }

    getPatientDataTransactionItemsByPatientCase(PatientCaseId: string): Observable<dataPatientCaseWorkItem[]> {
        return this.http.get<dataPatientCaseWorkItem[]>(`/api/accountReceivable/getTransactionItemsByPatientCase/${PatientCaseId}`);
    }

    getDoctorFeeForCode(DocFeeScheduleID: string, Code: string): Observable<FeeScheduleItemFeeDataModel> {
        return this.http.get<FeeScheduleItemFeeDataModel>(`/api/accountReceivable/getDoctorFeeForCode/${DocFeeScheduleID}/${Code}`);
    }

    dataPatientCaseWorkItem(caseWorkItem: DataPatientCaseWorkItemModel): Observable<DataPatientCaseWorkItemModel> {
        return this.http.post<DataPatientCaseWorkItemModel>('/api/accountReceivable/savePatientCaseWorkItem', caseWorkItem);
    }

    saveLedgerItem(saveLedgerItem: DataARLedgerModel): Observable<DataARLedgerModel> {
        return this.http.post<DataARLedgerModel>('/api/accountReceivable/saveLedgerItem', saveLedgerItem);
    }

    resolveLedgerCreditItems(creditObj: DataArLedgerCredits): Observable<boolean> {
        return this.http.post<boolean>('/api/accountReceivable/postResolveLedgerCreditItems', creditObj);
    }

    resolveLedgerCreditItems2(creditObj: DataArLedgerCredits): Observable<boolean> {
        return this.http.post<boolean>('/api/accountReceivable/postResolveLedgerCreditItems2', creditObj);
    }

    updateLedgerItem(updateLedgerItem: DataARLedgerListModel[], forceVoid: boolean = false): Observable<DataARLedgerListModel[]> {
        return this.http.post<DataARLedgerListModel[]>(`/api/accountReceivable/update-ledger-item?f=${forceVoid?1:0}`, updateLedgerItem);
    }

    createClaimFromTransactions(claimCreationObj: CreateClaimsModel): Observable<dataARClaim> {
        return this.http.post<dataARClaim>('/api/accountReceivable/create-claim-from-transactions', claimCreationObj);
    }

    createClaimFromLedgerItems(claimCreationObj: CreateClaimsModel): Observable<dataARClaim> {
        return this.http.post<dataARClaim>('/api/accountReceivable/create-claim-from-ledger-items', claimCreationObj);
    }

    getLedgerItemsForTransactions(transactionItems: DataARTransactionItemModel[]): Observable<DataARLedgerModel[]> {
        return this.http.post<DataARLedgerModel[]>('/api/accountReceivable/get-ledger-items-for-transactions', transactionItems);
    }

    savePaymentPlan(paymentPlan: dataARPaymentPlan): Observable<dataARPaymentPlan> {
        return this.http.post<dataARPaymentPlan>('/api/accountReceivable/savePaymentPlan', paymentPlan);
    }

    getPaymentPlansForPatient(PatientId: string): Observable<DataARPaymentPlanModel[]> {
        return this.http.get<DataARPaymentPlanModel[]>(`/api/accountReceivable/getPaymentPlansForPatient/${PatientId}`);
    }

    getCreditsForLedger(PatientId: string): Observable<DataArLedgerCredits> {
        return this.http.get<DataArLedgerCredits>(`/api/accountReceivable/getCreditsForLedger/${PatientId}`);
    }

    getARVariablesByTDOCID(): Observable<FeeVariablesModel> {
        return this.http.get<FeeVariablesModel>('/api/accountReceivable/getARVariablesByTDOCID');
    }
    getListOfFeeScedules(): Observable<any[]> {
        return this.http.get<any>('/api/accountReceivable/getListOfFeeSchedules');
    }

    getPaymentPlan(PaymentPlanID: string): Observable<dataARPaymentPlan> {
        return this.http.get<dataARPaymentPlan>(`/api/accountReceivable/getPaymentPlan/${PaymentPlanID}`);
    }

    savePaymentPlanItem(planItem: dataARPaymentPlanItem): Observable<dataARPaymentPlanItem> {
        return this.http.post<dataARPaymentPlanItem>('/api/accountReceivable/savePaymentPlanItem', planItem);
    }

    getAllPaymentPlans(): Observable<dataARPaymentPlan[]> {
        return this.http.get<dataARPaymentPlan[]>('/api/accountReceivable/getAllPaymentPlans');
    }

    saveClaimStatus(claim: DataARClaimModel): Observable<DataARClaimModel> {
        return this.http.post<DataARClaimModel>('/api/accountReceivable/save-claim-status', claim);
    }

    saveClaimNarrativeAttachment(ARClaimID: string, note: NoteDataModel): Observable<DataARClaimNarrativeAttachmentModel> {
        return this.http.post<DataARClaimNarrativeAttachmentModel>(`/api/accountReceivable/save-claim-narrative-attachment/${ARClaimID}`, note);
    }

    saveClaimMethod(claim: DataARClaimModel): Observable<DataARClaimModel> {
        return this.http.post<DataARClaimModel>('/api/accountReceivable/save-claim-method', claim);
    }

    saveClaimCheckStatus(claim: DataARClaimModel): Observable<DataARClaimModel> {
        return this.http.post<DataARClaimModel>('/api/accountReceivable/save-claim-check-status', claim);
    }

    updateDataPatientCaseWorkItemTooth(teeth: DataPatientCaseWorkItemModel[], CaseWorkItemId: string): Observable<DataPatientCaseWorkItemModel[]> {
        return this.http.post<DataPatientCaseWorkItemModel[]>(`/api/accountReceivable/updateDataPatientCaseWorkItemTooth/${CaseWorkItemId}`, teeth);
    }

    saveTransactionItemUpdateFees(transactionItem: DataARTransactionItemModel, PatientID: string, itemChanged: number): Observable<DataARTransactionItemModel> {
        return this.http.post<DataARTransactionItemModel>(`/api/accountReceivable/save-transaction-item-update-fees/${itemChanged}/${PatientID}`, transactionItem);
    }

    getPaymentProcessorDevicesByWorkstation(WorkstationID: string, LOCID: string): Observable<PaymentProcessorDeviceListModel[]> {
        return this.http.get<PaymentProcessorDeviceListModel[]>(`/api/payment-processor-configuration/payment-processor-devices-by-workstation/${WorkstationID}/${LOCID}`);
    }

    getPaymentProcessorList(LOCID: string): Observable<CfgARPaymentProcessorModel[]> {
        return this.http.get<CfgARPaymentProcessorModel[]>(`/api/payment-processor-configuration/payment-processor-by-location/${LOCID}`);
    }

    getPaymentProcessors(): Observable<CfgARPaymentProcessorModel[]> {
        return this.http.get<CfgARPaymentProcessorModel[]>('/api/payment-processor-configuration/get-payment-processors');
    }

    getCaseWorkItemTeethSurfaces(CaseWorkItemID: string): Observable<DataPatientCaseWorkItemToothSurfaceModel[]> {
        return this.http.get<DataPatientCaseWorkItemToothSurfaceModel[]>(`/api/cases/get-case-work-item-teeth-surfaces/${CaseWorkItemID}`);
    }

    saveCaseWorkItemTeethSurfaces(CaseWorkItemToothID: string, ToothSurfaceList: string[]): Observable<number> {
        return this.http.post<number>(`/api/cases/save-case-work-item-teeth-surfaces/${CaseWorkItemToothID}`, ToothSurfaceList);
    }

    // rectangle health

    sendRectangleHealthCreditTransaction(payload: RectangleHealthTransactionPayload): Observable<RectangleHealthTransactionResponseModel> {
        return this.http.post<RectangleHealthTransactionResponseModel>('/api/accountReceivable/send-rectangle-health-credit-transaction', payload);
    }

  sendRectangleHealthRefundTransaction(payload: RectangleHealthTransactionPayload): Observable<RectangleHealthTransactionResponseModel> {
    return this.http.post<RectangleHealthTransactionResponseModel>('/api/accountReceivable/send-rectangle-health-refund-transaction', payload);
  }

    requestCreditCardRefund(payload: CreditCardRefundRequest) {
        return this.http.post<CreditCardRefundResponse>('api/paymentprocessor/creditcardrefund', payload);
    }

    updateCreditCardRefundPaymentDistributions(PaymentID: string, ccRefundRecords: CreditCardRefundablePaymentModel[]) {
      return this.http.post<CreditCardRefundResponse>(`api/accountReceivable/update-credit-card-refund-payment-distributions/${PaymentID}`, ccRefundRecords);
    }
    getRectangleHealthTransaction(paymentProcessorID: string, invoiceNumber: string): Observable<RectangleHealthTransactionResponseModel> {
        return this.http.get<RectangleHealthTransactionResponseModel>(`/api/accountReceivable/get-rectangle-health-credit-transaction/${invoiceNumber}/${paymentProcessorID}`);
    }

    sendRectangleHealthVoidTransaction(payload: RectangleHealthTransactionPayload): Observable<RectangleHealthTransactionResponseModel> {
        return this.http.post<RectangleHealthTransactionResponseModel>('/api/accountReceivable/send-rectangle-health-void-transaction', payload);
    }

    // tripos

    // sendTriPosCreditTransaction(payload: TriPosCloudTransactionPayload): Observable<TriposCloudTransactionResponseModel> {
    //     return this.http.post<TriposCloudTransactionResponseModel>('/api/accountReceivable/send-tripos-credit-transaction', payload);
    // }

    // sendTriPosVoidTransaction(payload: TriPosCloudTransactionPayload): Observable<TriposCloudTransactionResponseModel> {
    //     return this.http.post<TriposCloudTransactionResponseModel>('/api/accountReceivable/send-tripos-void-transaction', payload);
    // }

    // sendTriPosReversalTransaction(payload: TriPosCloudTransactionPayload): Observable<TriposCloudTransactionResponseModel> {
    //     return this.http.post<TriposCloudTransactionResponseModel>('/api/accountReceivable/send-tripos-reversal-transaction', payload);
    // }

    // sendTriPosRefundTransaction(payload: TriPosCloudTransactionPayload): Observable<TriposCloudTransactionResponseModel> {
    //     return this.http.post<TriposCloudTransactionResponseModel>('/api/accountReceivable/send-tripos-refund-transaction', payload);
    // }

    createLedgerItemForPayment(payload: CreateLedgerItemForPaymentModel): Observable<CreateLedgerItemForPaymentModel> {
        return this.http.post<CreateLedgerItemForPaymentModel>('/api/accountReceivable/create-ledger-item-for-payment', payload);
    }

    voidPayment(paymentID: string, reason: string): Observable<string> {
      return this.http.post<string>(`/api/accountReceivable/void-payment/${paymentID}/${reason}`, {});
    }

    voidWriteOff(ledgerID: string, note: NoteDataModel): Observable<string> {
      return this.http.post<string>(`/api/accountReceivable/void-writeoff/${ledgerID}`, note);
    }

    // moved to tdo-shared.service.ts
    saveUserParams(ParamValue: string, UserID: string, ParamName: string): Observable<number> {
        const payload = {
            paramValue: ParamValue,
        };
        return this.http.post<number>(`/api/accountReceivable/save-user-params/${UserID}/${ParamName}`, payload);
    }

    getUserParams(UserID: string, ParamName: string): Observable<TdoUserParameters> {
        return this.http.get<TdoUserParameters>(`/api/accountReceivable/get-user-params/${UserID}/${ParamName}`);
    }





    getDebitCreditReasons(LOCID: number, ignoreCache: boolean=false): Observable<DataARCreditDebitReasonModel[]> {

        let cacheString = '';
        if (ignoreCache) {
            cacheString = '?t=' + new Date().getTime();
        }
        return this.http.get<DataARCreditDebitReasonModel[]>(`/api/accountReceivable/get-credit-debit-reasons/${LOCID}${cacheString}`);
    }

    getCCPaymentRecordsForPatient(PatientID: string): Observable<DataARPaymentModel[]> {
        return this.http.get<DataARPaymentModel[]>(`/api/accountReceivable/get-cc-payment-records-for-patient/${PatientID}`);
    }

    getPaymentTokenForPatient(PatientID: string): Observable<DataArPaymentToken[]> {
        return this.http.get<DataArPaymentToken[]>(`api/accountReceivable/getPaymentToken/${PatientID}`);
    }

    saveCCPaymentTokenInfo(saveInfo: string){
        return this.http.post<DataArPaymentToken[]>(`api/accountReceivable/savePaymentToken/${saveInfo}`, {});
    }


    DeleteCreditDebitReason(CreditDebitReasonID: string): Observable<string> {
        return this.http.post<string>(`/api/accountReceivable/delete-credit-debit-reason/${CreditDebitReasonID}`, {});
    }

    SaveCreditDebitReasons(CreditDebitReasons: DataARCreditDebitReasonModel[]): Observable<DataARCreditDebitReasonModel[]> {
        return this.http.post<DataARCreditDebitReasonModel[]>('/api/accountReceivable/save-credit-debit-reasons', CreditDebitReasons);
    }

  // updatePatientBalance(PatientID: string, Amount: number): Observable<number> {
  //   return this.http.post<number>(`/api/accountReceivable/update-patient-balance/${PatientID}/${Amount}`, {});
  // }

  // updatePatientBalance2(PatientID: string): Observable<number> {
  //   return this.http.post<number>(`/api/accountReceivable/update-patient-balance2/${PatientID}`, {});
  // }

    getDoctorARLocationIntegration(LOCID: number, DoctorId: string): Observable<CfgARAccountModel[]> {
        return this.http.get<CfgARAccountModel[]>(`/api/accountReceivable/doctors/${DoctorId}/locationintegration/${LOCID}`);
    }

    getPaymentReceipt(paymentID: string): Observable<PaymentReceiptModel> {
        return this.http.get<PaymentReceiptModel>(`api/accountReceivable/payments/${paymentID}/receipt`);
    }

    getIsDentalExchangeConfiguredForLocation(LOCID: number): Observable<number> {
        return this.http.get<number>(`api/accountReceivable/is-dental-exchange-configured/${LOCID}`);
    }

    getValPayPaymentStatus(paymentID: string): Observable<ITDOPaymentStatusResult>{
        return this.http.get<ITDOPaymentStatusResult>(`api/paymentprocessor/adyen/payment/${paymentID}/status`).pipe(
            retryWhen(errors => errors.pipe(
                switchMap((error) => {
                    console.log('getValPayPaymentStatus error', error);
                    if (error.status === 504 || error.status === 503 || error.status === 500) {
                        return of(error.status);
                    }
                    return throwError({message: error.error.message || 'Notification.Core.loginError'});
                }),
                scan(acc => acc + 1, 0),
                takeWhile(acc => acc < 3),
                delay(1500)
            ))
        );
    }

    processValpayTokenPayment(paymentAmount: number, transactionIdentifier: string, token: DataArPaymentToken): Observable<CreditCardTokenPaymentResponse>{
        return this.http.post<CreditCardTokenPaymentResponse>(`api/paymentprocessor/adyen/tokenPaymentRequest/${paymentAmount}/${transactionIdentifier}`, token);
    }

    validateChargeVoid(ledgerID: string): Observable<VoidValidationModel> {
        return this.http.get<VoidValidationModel>(`api/accountReceivable/${ledgerID}/validatevoid`);
    }
    // saveDataPaymentInvoice(paymentId: string, invoiceObject: InvoiceStringObj): Observable<dataARPayment> {
    //   const payload = {
    //     invoiceString: JSON.stringify(invoiceObject),
    //   };
    //   const invoiceString: string = JSON.stringify(invoiceObject);
    //   return this.http.post<dataARPayment>(`/api/accountReceivable/saveDataPaymentInvoice/${paymentId}`, payload);
    // }

    // processSuccessWPPayment(invoiceId: string): Observable<string> {
    //   return this.http.post<string>(`api/accountReceivable/processSuccessWPPayment/${invoiceId}`, {});
    // }

    // applyDiscountOnServer(transactionItem: DataARTransactionItemModel, level: number, patientId: string): Observable<DataARTransactionItemModel[]> {
    //   return this.http.post<DataARTransactionItemModel[]>(`/api/accountReceivable/applyDiscountOnServer/${level}/${patientId}`, transactionItem);
    // }
}
